import HttpFactory from '../factory'
import type { EpisodeOfCareStatus, IPriorityPatient } from '../types/priorityPatients'

class PriorityPatientsModule extends HttpFactory<any[]> {
  private PATH = '/priority-patients'

  private firstTime = true
  async get(options: { episodeOfCareStatuses?: EpisodeOfCareStatus[]; showAllPatients?: boolean } = {}): Promise<any> {
    let arr: IPriorityPatient[] = []
    const { episodeOfCareStatuses, showAllPatients } = options
    let queryParams = new URLSearchParams({ pageSize: this.firstTime ? '50' : '200' })

    if (episodeOfCareStatuses && episodeOfCareStatuses.length > 0) {
      const episodeOfCareStatusesStr = episodeOfCareStatuses.join(',')
      queryParams.set('episodeOfCareStatuses', episodeOfCareStatusesStr)
    }

    if (showAllPatients !== undefined) {
      queryParams.set('showAllPatients', showAllPatients ? 'true' : 'false')
    }

    let nextPageUrl = `?${queryParams.toString()}`

    await this.call<any>('GET', `${this.PATH}/${nextPageUrl}`).then((response) => {
      arr = arr.concat(response.items)
      nextPageUrl = response.nextPageUrl
      this.firstTime = false
    })
    return { items: arr, nextPageUrl }
  }

  async getNextPage(nextPage: string): Promise<any> {
    let arr: IPriorityPatient[] = []
    let nextPageUrl = nextPage.replace('pageSize=50', 'pageSize=200')
    await this.call<any>('GET', `${this.PATH}/${nextPageUrl}`).then((response) => {
      arr = arr.concat(response.items)
      nextPageUrl = response.nextPageUrl
    })
    return { items: arr, nextPageUrl }
  }
}

export default PriorityPatientsModule
